export default __webpack_public_path__ + "static/media/great_score_icon.34bff568.svg";